import {
  InvitationTokenPayload,
  readInvitationTokenPayload,
} from '@/features/public/acceptInvitation/utils/invitationTokenPayload.ts';

const ACCEPT_INVITATION_PATH = '/accept-invitation';

export const readInvitationFromRedirect = (
  redirect: string | undefined,
): InvitationTokenPayload | null => {
  if (!redirect?.startsWith(ACCEPT_INVITATION_PATH)) return null;
  const queryStart = redirect.indexOf('?');
  if (queryStart === -1) return null;
  const token = new URLSearchParams(redirect.slice(queryStart + 1)).get(
    'token',
  );
  return token ? readInvitationTokenPayload(token) : null;
};
